import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getOptimizedImageUrl = (url: string | null | undefined): string | null | undefined => {
  if (!url || typeof url !== 'string') return url
  if (url.includes('cloudinary.com') && url.includes('/v')) {
    return url.replace('/v', '/w_400,q_auto,f_auto/v')
  }
  return url
}
